// extracted by mini-css-extract-plugin
export var fullWidthButton = "_fn-0";